<mat-card class="height-100">
  <mat-card-header>
    <mat-card-title>Adicionar instituição financeira</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="mt-2 col-md-12">
      <span class="p-float-label">
        <input
          type="text"
          id="inputtext-right"
          pInputText
          [formControl]="form.get('cnpj')"
          [mask]="'00.000.000/0000-00'"
          (blur)="checkCnpj()"
          class="input-filters"
        />
        <label for="inputtext-right"> CNPJ * </label>
      </span>
      <small
        class="p-error"
        *ngIf="
          form.get('cnpj').touched && form.get('cnpj').hasError('required')
        "
      >
        {{ displayMessages.cnpj.required }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('cnpj').touched && form.get('cnpj').hasError('mask')"
      >
        {{ displayMessages.cnpj.mask }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('cnpj').touched && form.get('cnpj').hasError('repeated')
        "
      >
        {{ displayMessages.cnpj.repeated }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('cnpj').touched && form.get('cnpj').hasError('pattern')"
      >
        {{ displayMessages.cnpj.pattern }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('cnpj').touched && form.get('cnpj').hasError('maxlength')
        "
      >
        {{ displayMessages.cnpj.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('cnpj').touched && form.get('cnpj').hasError('validateCNPJ')
        "
      >
        {{ displayMessages.cnpj.validateCNPJ }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('cnpj').touched && form.get('cnpj').hasError('duplicate')
        "
      >
        {{ displayMessages.cnpj.duplicate }}
      </small>
    </div>
    <div class="mt-2 col-md-12 mt-2">
      <span class="p-float-label">
        <input
          id="inputtext-sigla"
          class="input-filters"
          pInputText
          [formControl]="form.get('descricao')"
          type="text"
          autocomplete="off"
        />
        <label for="inputtext-sigla">Descrição *</label>
      </span>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('required')
        "
      >
        {{ displayMessages.descricao.required }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('maxlength')
        "
      >
        {{ displayMessages.descricao.maxlength }}
      </small>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <div class="mt-2 col-md-12 pb-2 flex justify-content-end">
      <button
        [disabled]="loading"
        mat-stroked-button
        color="warn"
        (click)="dialogRef.close()"
      >
        Cancelar
      </button>
      <button
        [disabled]="loading || !form.valid"
        mat-raised-button
        color="primary"
        (click)="submit()"
      >
        Cadastrar
      </button>
    </div>
  </mat-card-actions>
</mat-card>
